/* eslint-disable */
export default {
  title: 'Répondre par un message vocal',
  customMessage: 'Message personnalisé',
  customMessagePlaceholder: 'Saisir un message personnalisé',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
